/**
 * @generated SignedSource<<fbca8368f9e78484f2cac9387d8125a7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type renderChildRows_nativeIssueTable_RenderChildRowsComp$data = {
  readonly fieldId: string | null | undefined;
  readonly jqlTerm: string;
  readonly " $fragmentType": "renderChildRows_nativeIssueTable_RenderChildRowsComp";
};
export type renderChildRows_nativeIssueTable_RenderChildRowsComp$key = {
  readonly " $data"?: renderChildRows_nativeIssueTable_RenderChildRowsComp$data;
  readonly " $fragmentSpreads": FragmentRefs<"renderChildRows_nativeIssueTable_RenderChildRowsComp">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "renderChildRows_nativeIssueTable_RenderChildRowsComp",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "jqlTerm"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "86a99b8c4c5da75c27916f23c311eef3";

export default node;
